/*
 * Title: GentleApi Obejct 
 * Author: KimTaeOh (taeoh.kim@gentlepie.com )
 * Date: 2021-04-03
 */

export default {
    type: {
        Bot: 'Bot',// '{name}님, 판매일자 변경이 가능한 주문내역을 보여드릴게요.<br>[판매일자 변경] 버튼을 누르면, 해당 내역의 판매일자 변경이 가능합니다.',
        Title: 'Title',// '판매일자 변경하기',
        More: 'More', // '변경 가능한 주문내역 더보기',
        NotFound: 'NotFound', // {name}님, 판매일자 변경이 가능한 주문내역이 없어요. 아래 버튼을 눌러 주문내역을 확인해보세요.'
        Info: 'Info',// '가상계좌 결제 이용시에는 입금전까지 계속 수정이 가능합니다.<br>결제완료시 출고전 1회만 수정 가능합니다.',
        Date: 'Date',// '변경가능한 일자',
        Select: 'Select',
        ListInfo: 'ListInfo',
        Dates: 'Dates',
        Now: 'Now', // 
        Cant: 'Cant',
        Done: 'Done',
        Zero: 'Zero', //20000err
        ZeroOne: 'ZeroOne', //20001err
        ZeroTwo: 'ZeroTwo', //20002err

    },
    tomy:{
        kr: {
            Bot: '{name}님, 판매일자 변경이 가능한 주문내역입니다.',
            Title: '판매일자 변경하기',
            More: '변경 가능한 주문내역 더보기',
            NotFound: '{name}님, 판매일자 변경이 가능한 주문내역이 없습니다. 아래 버튼을 누르면 주문내역을 확인하실 수 있어요.',
            Info: '가상계좌 결제 시, 판매일자는 입금 전 언제든 변경 가능합니다. 결제 완료 이후엔 출고 전 1회에 한해 일자를 변경할 수 있어요.',
            Date: '변경가능한 일자',
            Select: '변경 일자 선택 완료',
            ListInfo: '최근 5건의 주문내역 중 판매일자를 변경할 수 있는 주문 건입니다.',
            Dates: '변경 가능한 날짜',
            Now: '현재 판매일자',
            Cant: '{name}님, 판매일자 변경이 가능한 주문내역이 없습니다. 아래 버튼을 누르면 주문내역을 확인하실 수 있어요.',
            Done: '판매일자 변경이 완료되었습니다.',
            Zero: '판매일자가 올바르지 않습니다.',
            ZeroOne: '주문정보를 찾을 수 없습니다.',
            ZeroTwo: '판매일자를 변경할 수 없습니다.',
        },
        eng: {
            Bot: '{name}, this is an order history that allows you to change the sale date.',
            Title: 'Change the sale date',
            More: 'View more changeable order details',
            NotFound: '{name}, there is no order history to change the sale date. You can check your order history by clicking the button below.',
            Info: 'When paying using a virtual account, the sales date can be changed at any time before deposit. After payment is complete, you can change the date only once before shipping.',
            Date: 'Dates subject to change.',
            Select: 'New date selected',
            ListInfo: 'This is an order in which the sale date can be changed among the last 5 orders.',
            Dates: 'Dates subject to change',
            Now: 'Current sales dates',  
            Cant: '{name}, there is no order history to change the sale date. You can check your order history by clicking the button below.',         
            Done: 'Sales date change is complete.',
            Zero: 'Sales date in not valid.',
            ZeroOne: 'Order information not found.',
            ZeroTwo: 'Unable to change sales date',
        }
    },
    papa:{
        kr: {
            Bot: '{name}님, 판매일자를 변경할 수 있는 주문내역이에요.',
            Title: '판매일자 변경하기',
            More: '변경 가능한 주문내역 더보기',
            NotFound: '{name}님, 지금은 판매일자를 변경할 수 있는 주문이 없네요. [주문내역 보기]를 눌러 자세히 알아보겠어요?',
            Info: '가상계좌 결제 시, 판매일자는 입금 전 언제든 변경 가능합니다. 결제 완료 이후엔 출고 전 1회에 한해 일자를 변경할 수 있어요.',
            Date: '변경가능한 일자',
            Select: '변경 일자 선택 완료',
            ListInfo: '최근 {count}건 주문내역 중 변경 가능한 건을 보여드려요. 더 많은 주문내역을 보려면 하단 버튼을 누르세요.',
            Dates: '변경 가능한 날짜',
            Now: '현재 판매일자', 
            Cant: '{name}님, 지금은 판매일자를 변경할 수 있는 주문이 없네요. [주문내역 보기]를 눌러 자세히 알아보겠어요?',                     
            Done: '판매일자 변경이 완료되었어요.',
            Zero: '앗! 판매일자가 올바르지 않아요.',
            ZeroOne: '주문정보를 찾을 수 없어요. 다시 한번 확인해보시겠어요?.',
            ZeroTwo: '판매일자를 변경할 수 없네요. 다시 한번 확인해보시겠어요?',
        },
        eng: {
            Bot: '{name}, this is an order history that allows you to change the sale date.',
            Title: 'Change the sale date',
            More: 'View more changeable order details',
            NotFound: 'Dear {name}, there are currently no orders to change the sale date. Would you like to know more by clicking [View Order History]?',
            Info: 'When paying using a virtual account, the sales date can be changed at any time before deposit. After payment is complete, you can change the date only once before shipping.',
            Date: 'Dates subject to change',
            Select: 'New date selected',
            ListInfo: 'This is an order in which the sale date can be changed among the last 5 orders.',
            Dates: 'Dates subject to change',
            Now: 'Current sales dates',   
            Cant: 'Dear {name}, there are currently no orders to change the sale date. Would you like to know more by clicking [View order history]?',                   
            Done: 'Sales date change is complete.',
            Zero: 'Oh, Sales date in not valid.',
            ZeroOne: 'Order information not found. Please, Check agian?',
            ZeroTwo: 'Unable to change sales date, Please check agian?', 
        }
    },
};
